import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { DataTable } from '@shopify/polaris';

import { tAttribute } from '@utils';

const propTypes = {
  products: PropTypes.array.isRequired,
};


class ProductsTable extends PureComponent {
  render() {
    //console.log(this.props);
    return (
      <DataTable
        columnContentTypes={[
          'text',
          'text',
          'number',
          'text',
          'text',
          'text'
        ]}
        headings={[
          tAttribute("product", "title"),
          tAttribute("product", "user"),
          tAttribute("product", "inventory_quantity"),
          tAttribute("product", "status"),
          tAttribute("product", "apb"),
          ""
        ]}
        rows={this.props.products}
      />
    );
  }
}


ProductsTable.propTypes = propTypes;


export default ProductsTable;
